import React, { useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const AdminLoginTest = () => {
  const [email, setEmail] = useState('admin@proptraders.com');
  const [password, setPassword] = useState('admin123');
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const testLogin = async () => {
    setError(null);
    setResult(null);
    
    try {
      console.log('Testing login with:', { email, password });
      const response = await axios.post(`${API_URL}/auth/login`, {
        email,
        password
      });
      
      console.log('Login response:', response.data);
      setResult(JSON.stringify(response.data, null, 2));
      
      // Store token
      localStorage.setItem('token', response.data.access_token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      
      alert('Login successful! Token stored. Role: ' + response.data.user.role);
      
      // Manual redirect
      if (response.data.user.role === 'admin') {
        window.location.href = '/admin';
      } else {
        window.location.href = '/dashboard';
      }
      
    } catch (err) {
      console.error('Login error:', err);
      setError(err.response?.data?.detail || err.message);
    }
  };

  const checkStorage = () => {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    alert(`Token: ${token ? 'EXISTS' : 'NONE'}\nUser: ${user || 'NONE'}`);
  };

  const clearStorage = () => {
    localStorage.clear();
    alert('Storage cleared');
  };

  return (
    <div style={{
      padding: '40px',
      background: '#0B0B0B',
      minHeight: '100vh',
      color: 'white',
      fontFamily: 'monospace'
    }}>
      <h1 style={{ color: '#D4AF37' }}>Admin Login Test</h1>
      
      <div style={{ marginBottom: '20px' }}>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          style={{
            padding: '10px',
            width: '300px',
            display: 'block',
            marginBottom: '10px',
            background: '#1a1a1a',
            border: '1px solid #333',
            color: 'white'
          }}
        />
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          style={{
            padding: '10px',
            width: '300px',
            display: 'block',
            marginBottom: '10px',
            background: '#1a1a1a',
            border: '1px solid #333',
            color: 'white'
          }}
        />
      </div>

      <div style={{ marginBottom: '20px' }}>
        <button onClick={testLogin} style={{
          padding: '10px 20px',
          marginRight: '10px',
          background: '#D4AF37',
          border: 'none',
          color: '#0B0B0B',
          cursor: 'pointer',
          fontWeight: 'bold'
        }}>
          Test Login
        </button>
        <button onClick={checkStorage} style={{
          padding: '10px 20px',
          marginRight: '10px',
          background: '#0EA5E9',
          border: 'none',
          color: 'white',
          cursor: 'pointer'
        }}>
          Check Storage
        </button>
        <button onClick={clearStorage} style={{
          padding: '10px 20px',
          background: '#EF4444',
          border: 'none',
          color: 'white',
          cursor: 'pointer'
        }}>
          Clear Storage
        </button>
      </div>

      {error && (
        <div style={{
          padding: '20px',
          background: '#EF4444',
          borderRadius: '8px',
          marginBottom: '20px'
        }}>
          <strong>Error:</strong> {error}
        </div>
      )}

      {result && (
        <div style={{
          padding: '20px',
          background: '#1a1a1a',
          borderRadius: '8px',
          border: '1px solid #10B981'
        }}>
          <strong style={{ color: '#10B981' }}>Success:</strong>
          <pre style={{ marginTop: '10px', fontSize: '12px' }}>{result}</pre>
        </div>
      )}

      <div style={{ marginTop: '40px', padding: '20px', background: '#1a1a1a', borderRadius: '8px' }}>
        <h3>Instructions:</h3>
        <ol>
          <li>Click "Test Login" to test admin credentials</li>
          <li>Check browser console (F12) for logs</li>
          <li>Click "Check Storage" to verify token is saved</li>
          <li>If successful, you'll be redirected to /admin</li>
        </ol>
        
        <h3 style={{ marginTop: '20px' }}>Backend URL:</h3>
        <code>{API_URL}</code>
      </div>
    </div>
  );
};

export default AdminLoginTest;
